import React, { useState, useEffect } from "react";
import "../Footer/Footer.css";
import { createDoc } from "../../Firebase_Config/firebaseConfig";
import axios from "axios";
import { Link } from "react-router-dom";
import ServiceNavBar from "../../Components/Navbars/ServiceNavBar";
import { useLocation, useNavigate } from "react-router-dom";
const backendURL = "https://mailing-backend-qiqy.onrender.com";

const CheckOutForm = () => {
  const navigate = useNavigate();
  const serviceNav1 = [
    { title: "Home", link: "/", type: "NavLink" },
    { title: "Contact Us", link: "contactuspage", type: "Link" },
    { title: "Services", link: "/Services", type: "NavLink" },
  ];

  const [newContact, setNewContact] = useState({
    name: "",
    email: "",
    number: "",
    company: "",
    course: "",
    businessType: "",
  });

  const location = useLocation();
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [authenticated, setAuthenticated] = useState(
    localStorage.getItem("authenticated")
  );
  const [alertMsg, setAlertMsg] = useState(localStorage.getItem("alertMsg"));
  const [alertColor, setAlertColor] = useState(
    localStorage.getItem("alertColor")
  );

  const handleOnChange = (e) => {
    setNewContact({ ...newContact, [e.target.name]: e.target.value });
    const inputs = document.querySelectorAll("input, select");
    const validity = [...inputs].every((input) => input.checkValidity());
    setIsValid(validity);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      const savedName = newContact.name.trim();
      const savedEmail = newContact.email.trim();
      const savedCompany = newContact.company.trim();

      await axios
        .post(`${backendURL}/feedback`, {
          name: savedName,
          email: savedEmail,
          num: newContact.number,
          company: savedCompany,
        })
        .then(function (res) {
          createDoc(newContact);
          setIsValid(true);
          setMsg("Message Sent Successfully. We will be in touch with you soon.");
          setSending(false);
          setTimeout(() => {
            setNewContact({
              name: "",
              email: "",
              number: "",
              company: "",
              course: "",
              businessType: "",
            });
          }, 3000);
          navigate("/confirmWindow");
        })
        .catch(function (error) {
          setMsg(`The Following Error Occurred: ${error.message}`);
          setSending(false);
        });
    } catch (error) {
      setSending(false);
      setMsg(`The Following Error Occurred: ${error.message}.\nKindly Try Again!`);
    }
  };
  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const course = params.get("course");
  const businessType = params.get("businessType");
  setNewContact((prev) => ({
    ...prev,
    course: course || prev.course,
    businessType: businessType || prev.businessType,
  }));
}, [location.search]);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const course = params.get("course");
    if (course) {
      setNewContact((prevContact) => ({ ...prevContact, course }));
    }
  }, [location.search]);

  const linkList = [serviceNav1];

  return (
    <>
      <ServiceNavBar
        navList={serviceNav1}
        authenticated={authenticated}
        setAuthenticated={setAuthenticated}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        alertColor={alertColor}
        setAlertColor={setAlertColor}
        linksList={linkList[0]}
      />

      <section id="contactuspage" className="contact-section flex">
        <Link to="/Services">
          <button className="bg-black text-white py-2 px-4 rounded-full">
            <img src="/back.svg" className="h-7 w-7" alt="" />
          </button>
        </Link>

        <div className="subheadings-1">
          <span>FUEL.</span>
          <span>ELEVATE.</span> <span>IGNITE YOUR</span>
          <span>SW SOLUTIONS.</span>
        </div>

        <form
          onSubmit={handleFormSubmit}
          className="bg-black border shadow-lg p-8 rounded-lg max-w-md mx-auto space-y-6"
        >
          <h1 className="text-white text-4xl font-semibold mb-4 text-center">
            Get Your Quotation
          </h1>

          {msg && <p className="text-green-500 text-center">{msg}</p>}

          {/* Name */}
          <div className="flex flex-col space-y-1">
            <label htmlFor="name" className="text-sm text-gray-400 font-medium">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your Name"
              onChange={handleOnChange}
              value={newContact.name}
              required
              pattern="^[A-Za-z\s.]{3,50}$"
              className="p-3 border border-gray-400 rounded-md bg-transparent text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
          </div>

          {/* Email */}
          <div className="flex flex-col space-y-1">
            <label htmlFor="email" className="text-sm text-gray-400 font-medium">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Your Email"
              onChange={handleOnChange}
              value={newContact.email}
              required
              className="p-3 border border-gray-400 rounded-md bg-transparent text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
          </div>

          {/* Phone */}
          <div className="flex flex-col space-y-1">
            <label htmlFor="number" className="text-sm text-gray-400 font-medium">
              Phone Number
            </label>
            <input
              type="tel"
              id="number"
              name="number"
              placeholder="Your Phone Number"
              onChange={handleOnChange}
              value={newContact.number}
              required
              pattern="^(?:\+91|91|0)?[6-9]\d{9}$"
              className="p-3 border border-gray-400 rounded-md bg-transparent text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
          </div>

          {/* Purpose */}
          <div className="flex flex-col space-y-1">
            <label htmlFor="company" className="text-sm text-gray-400 font-medium">
              Purpose
            </label>
            <input
              type="text"
              id="company"
              name="company"
              placeholder="Your Company/Organization"
              onChange={handleOnChange}
              value={newContact.company}
              required
              className="p-3 border border-gray-400 rounded-md bg-transparent text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
          </div>

          {/* Selected Service */}
          <div className="flex flex-col space-y-1">
            <label htmlFor="course" className="text-sm text-gray-400 font-medium">
              Service Type
            </label>
            <select
              id="course"
              name="course"
              onChange={handleOnChange}
              value={newContact.course}
              required
              className="p-3 border border-gray-400 rounded-md bg-black text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              <option value="" disabled>
                Select Service Type
              </option>
              <option value="WebDev">Web Development</option>
              <option value="AppDev">App Development</option>
              <option value="UI-UX">UI/UX Design</option>
              <option value="Others">Others</option>
            </select>
          </div>

          {/* Business Type (New Dropdown) */}
          <div className="flex flex-col space-y-1">
            <label htmlFor="businessType" className="text-sm text-gray-400 font-medium">
              Business Type
            </label>
            <select
              id="businessType"
              name="businessType"
              onChange={handleOnChange}
              value={newContact.businessType}
              required
              className="p-3 border border-gray-400 rounded-md bg-black text-white focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              <option value="" disabled>
                Select Business Type
              </option>
              <option value="Education">Education</option>
              <option value="Delivery">Delivery</option>
              <option value="Taxi & Transportation">Taxi & Transportation</option>
              <option value="Fitness">Fitness</option>
              <option value="Rental">Rental</option>
              <option value="Consultation">Consultation</option>
              <option value="E-commerce">E-commerce</option>
              <option value="Freelancer">Freelancer</option>
              <option value="Social Platform">Social Platform</option>
              <option value="Real Estate">Real Estate</option>
              <option value="Others">Others</option>
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={!isValid || sending}
            className="w-full cursor-pointer inline-flex h-12 animate-shimmer items-center justify-center rounded-md border border-slate-800 bg-[linear-gradient(110deg,#000103,45%,#1e2631,55%,#000103)] bg-[length:200%_100%] px-6 font-medium text-white transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50"
          >
            {sending ? "Sending..." : "Get Service"}
          </button>
        </form>

        {/* Contact Details */}
        <div className="contact-container">
          <div className="contact-Details">
            <div className="subheadings-2">
              <span>Have an Idea?</span>
              <span>Tell us about it!</span>
            </div>
            <div className="address">
              <a href="mailto:connect@valscotech.com">connect@valscotech.com</a>
              <p>
                J-3 SHATABDI ENCLAVE
                <br />
                NOIDA, UTTAR PRADESH 201301
              </p>
              <div className="policies">
                <Link to="/PrivacyPage">
                  <span>Privacy Policy</span>
                </Link>
                <Link to="/RefundPolicy">
                  <span>Refund and Cancellation</span>
                </Link>
                <Link to="/T&C">
                  <span>Terms and Conditions</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="social-handles">
            <i className="fa fa-twitter fa-4x icon-3d" style={{ fontSize: "48px" }}></i>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-facebook fa-4x icon-3d" style={{ fontSize: "48px" }}></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-instagram fa-4x icon-3d" style={{ fontSize: "48px" }}></i>
            </a>
            <a
              href="https://www.linkedin.com/company/valscotech/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-linkedin fa-4x icon-3d" style={{ fontSize: "48px" }}></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default CheckOutForm;
